import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Legal imprint page component.
 *
 * @remarks Displays the company's legal imprint information including
 * company details, contact information, and regulatory compliance data
 * as required by German law (Impressum).
 */
@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class ImprintComponent {
  /**
   * Creates an instance of ImprintComponent.
   */
  constructor() {}
}
